import React, { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../actions/auth.action';
import avatar from '../../assets/img/avatar5.png';
import { useHistory } from 'react-router-dom';
import BusinessIcon from '@material-ui/icons/Business';
import SelectCompany from "../../components/SelectCompany";

const Navbar = ({ sidebarCollapsed, onToggleSidebar }) => {
  const history = useHistory();
  const proyects = useSelector(state => state.proyects);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  
  let user = JSON.parse(localStorage.getItem("user-s10"));

  return (
    <nav className="navbar navbar-expand navbar-primary navbar-dark p-0" style={{
      background: '#3c8dbc',
      height: '50px',
      width: '100%'
    }}>
      
      <div className="d-flex justify-content-between align-items-center w-100 px-3">
        
        <div className="d-flex align-items-center">
          <button 
            className="btn btn-link text-white p-1 mr-2"
            onClick={onToggleSidebar}
            style={{ textDecoration: 'none' }}
          >
            <i className="fas fa-bars"></i>
          </button>

          <span className="text-white mx-2" style={{ fontSize: '12px' }}>
            Tablero S10 |
          </span>

          <Breadcrumb className="mb-0">
            <Breadcrumb.Item className="text-white" style={{ fontSize: '14px' }}>
              {proyects.titleProject} {proyects.titlePC && proyects.pc ? proyects.titlePC : ''}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="d-flex align-items-center">
          <SelectCompany setShow={setShow} show={show} changeCompany={true} />
          
          <button 
            className="btn btn-link text-white p-1 mx-2"
            onClick={() => setShow(!show)}
            style={{ textDecoration: 'none' }}
          >
            <BusinessIcon style={{ transform: "scale(1.3)" }} />
          </button>
          
          <div className="dropdown">
            <button 
              className="btn btn-link text-white dropdown-toggle d-flex align-items-center p-1"
              style={{ 
                textDecoration: 'none',
                border: 'none',
                background: 'transparent'
              }}
              data-toggle="dropdown"
            >
              <img src={avatar} className="rounded-circle mr-2" width="25" alt="avatar" />
              <span style={{ fontSize: "12px" }}>
                {user && user.FullName}
              </span>
            </button>
            
            <div className="dropdown-menu dropdown-menu-right">
              <div className="dropdown-header">Colaborador</div>
              <div className="dropdown-divider"></div>
              <div className="px-3 py-2 text-center">
                <img src={avatar} alt="avatar" className="rounded-circle mb-2" width="60" />
                <h6 className="mb-1">{user && user.FullName}</h6>
                <small className="text-muted">{user && user.UserName}</small>
              </div>
              <div className="dropdown-divider"></div>
              <button 
                className="dropdown-item text-danger"
                onClick={() => dispatch(logOut(history))}
              >
                <i className="fas fa-sign-out-alt mr-2"></i>
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;